import { FC } from 'react';
import { Link } from 'react-router-dom';

import { ApplicationStatus } from 'entities/application/ui/ApplicationStatus/ApplicationStatus';
import {
	ApplicationItemContainerStyled,
	ApplicationItemContentStyled,
	ApplicationItemDescriptionStyled,
	ApplicationItemLogoStyled,
	ApplicationItemNameStyled,
	ApplicationItemTextContainerStyled,
} from './ApplicationListItemM.styles';

interface ApplicationListItemMProps {
	name: string;
	description: string;
	logoUrl: string;
	applicationId: string;
	status?: 'beta' | 'development' | 'new' | 'updated';
	descriptionCard?: string;
}

export const ApplicationListItemM: FC<ApplicationListItemMProps> = ({
	name,
	description,
	logoUrl,
	applicationId,
	status,
	descriptionCard,
}) => (
	<Link to={`/${applicationId}`}>
		<ApplicationItemContainerStyled>
			<ApplicationItemContentStyled>
				<ApplicationItemLogoStyled src={logoUrl} />
				<ApplicationItemTextContainerStyled>
					<ApplicationItemNameStyled>
						{name}
						{status && <ApplicationStatus status={status} />}
					</ApplicationItemNameStyled>
					<ApplicationItemDescriptionStyled>
						{descriptionCard ?? description.split(`.`)[0]}
					</ApplicationItemDescriptionStyled>
				</ApplicationItemTextContainerStyled>
			</ApplicationItemContentStyled>
		</ApplicationItemContainerStyled>
	</Link>
);
